import {
  Box,
  Dialog,
  Fab,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import ApplyExternalHours from './ApplyExternalHours';
import AddIcon from '@mui/icons-material/Add';
import ExternalHoursRequestCard from './ExternalHoursRequestCard';
import { checkFilterIconVisibility } from '../GenericFilter/FilterIconVisibilityCheck';
import GenericFilterDrawer from '../GenericFilter/GenericFilterDrawer';
import { useSelector } from 'react-redux';
import {
  GetExternalHrsRequestsForEmployee,
  GetExternalHrsRequestsForFinance,
  GetExternalHrsRequestsForSeniorManager,
} from '../../services/ExternalHrsService';
import { useLocation } from 'react-router-dom';
import KeycloakService from '../../services/KeycloakService';
import {
  getUserProjects,
} from '../../services/UserService';
import { getProjectsByName } from '../../services/ProjectService';
import { RESET_DATE_RANGE, WFHAttribute } from '../../constants';
import GenericLoader from '../Loader/GenericLoader';
import PaginationComponent from '../Pagination/Pagination';
import { useDispatch } from 'react-redux';
import {
  setFilterConfig,
  resetFilterDataState,
  setFilterDataState,
  setSelectedMonthRangeState,
} from '../../modules/filter/filterAction';
import { cardComponentCollapse, cardComponentExpand } from '../../modules/cardState/cardAction';
import { DateObject } from 'react-multi-date-picker';

const ExternalHours = (props) => {
  const currentUserId = KeycloakService.getUserDetail();
  const dispatch = useDispatch();
  const location = useLocation();

  const financePage = location.pathname.includes('/finance');
  const seniorManagerPage = location.pathname.includes('/senior-manager');
  const userPage = location.pathname.includes('/user-task');
  const requestCategory =
    props.requestCategory ||
    (location.pathname.includes('client-office')
      ? 'CLIENT_OFFICE'
      : location.pathname.includes('work-travel')
        ? 'WORK_TRAVEL'
        : 'EXTERNAL');
  const pageLabel =
    requestCategory === 'CLIENT_OFFICE'
      ? 'Client Office Hours'
      : requestCategory === 'WORK_TRAVEL'
        ? 'Work Travel Hours'
        : 'External Hours';
  const approverInboxPage = financePage || seniorManagerPage;

  const [userRequests, setUserRequests] = useState([]);
  const [open, setOpen] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [loader, setLoader] = useState(true);
  const [loader1, setLoader1] = useState(false);
  const [canApplyExternalHours, setCanApplyExternalHours] = React.useState(false);

  const [totalPage, setTotalPage] = React.useState();
  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = useState(3);
  const [pageNo, setPageNo] = React.useState(0);

  const [resetFilter, setResetFilter] = useState(false);

  const [projectArray, setProjectArray] = useState([]);
  const [options, setOptions] = useState({});

  const statusOptionsForFinance = [
    ['APPROVED', 'Approved'],
    ['PENDING', 'Pending'],
    ['SENIOR_MANAGER_APPROVED', 'Senior Manager Approved'],
    ['MANAGER_APPROVED', 'Manager Approved (Legacy)'],
    ['REJECTED', 'Rejected'],
    ['CANCELLED', 'Cancelled'],
  ];

  const statusOptionsForSeniorManager = [
    ['APPROVED', 'Approved'],
    ['PENDING', 'Pending'],
    ['SENIOR_MANAGER_APPROVED', 'Senior Manager Approved'],
    ['REJECTED', 'Rejected'],
    ['CANCELLED', 'Cancelled'],
  ];

  const statusOptionsForUser = [
    ['APPROVED', 'Approved'],
    ['PENDING', 'Pending'],
    ['SENIOR_MANAGER_APPROVED', 'Senior Manager Approved'],
    ['REJECTED', 'Rejected'],
    ['CANCELLED', 'Cancelled'],
    ['MANAGER_APPROVED', 'Manager Approved (Legacy)'],
    ['DISCARDED', 'Discarded'],
  ];

  const filterConfigurationForApprover = {
    inputField: [
      [
        ['status', 'Status'],
        financePage ? statusOptionsForFinance : statusOptionsForSeniorManager,
      ],
    ],
    autoComplete: [['Search Employee', 'employee']],
    dropdownField: [['Search Project', 'project', 'projectName', 'id']],
  };

  const filterConfigurationForUser = {
    inputField: [
      [
        ['status', 'Status'],
        statusOptionsForUser,
      ],
    ],
  };

  const getProjectsForApprover = async (pName) => {
    setLoader1(true);
    const projectList = await getProjectsByName(pName, 0, null);
    if (projectList?.status === 200) {
      setProjectArray([...projectList.data.content]);
      setOptions({ ...options, project: projectList.data.content });
    } else {
      setProjectArray([]);
      setOptions({ ...options, project: [] });
    }
    setLoader1(false);
  };

  const applyDeepLinkFilters = () => {
    const xyz = new URLSearchParams(location.search).get('xyz');
    if (!xyz) return;
    try {
      const searchString = window.atob(xyz);
      const params = new URLSearchParams(searchString);
      const applierId = params.get('applierId');
      const status = params.get('status');
      const monthRangeRaw = params.get('monthRange') || '[]';
      const monthRange = JSON.parse(monthRangeRaw);
      dispatch(
        setFilterDataState({
          employeeId: applierId || '',
          status: status || '',
          monthRange,
        }),
      );
      if (Array.isArray(monthRange) && monthRange.length === 4) {
        const startDate = new DateObject({
          year: monthRange[1],
          month: monthRange[0],
          day: 1,
        });
        const endDate = new DateObject({
          year: monthRange[3],
          month: monthRange[2],
          day: 1,
        });
        dispatch(setSelectedMonthRangeState([startDate, endDate]));
      }
      dispatch(cardComponentExpand());
    } catch (e) {
      // ignore malformed deep links
    }
  };

  useEffect(() => {
    resetThings();
    if (approverInboxPage) getProjectsForApprover();
    applyDeepLinkFilters();
    setResetFilter(true);
  }, []);

  useEffect(() => {
    setOptions({ ...options, project: projectArray });
  }, [projectArray]);

  const resetThings = () => {
    if (Array.isArray(filterConfiguration.dropdownField)) {
      for (let arrayOfArrays of filterConfiguration.dropdownField) {
        setOptions({ ...options, [arrayOfArrays[1]]: [] });
      }
    }
    dispatch(setFilterConfig(filterConfiguration));

    dispatch(resetFilterDataState());
    dispatch({
      type: RESET_DATE_RANGE,
    });
    dispatch(cardComponentCollapse());
  };

  const pageChange = (event, value) => {
    setPageNo(value - 1);
    setPage(value);
    setRefresh(!refresh);
    setLoader(true);
  };

  const handlePageSizeChange = (event) => {
    const newPageSize = event.target.value;
    setPageSize(newPageSize);
    pageChange(null, 1);
    setRefresh(!refresh);
    setLoader(true);
  };

  const filterState = useSelector((state) => state.filterState);

  const emptyFilterDataUser = {
    status: '',
    monthRange: [],
  };

  const emptyFilterDataApprover = {
    status: '',
    employeeId: '',
    year: '',
    employeeName: '',
    monthRange: [],
    projectName: '',
  };

  const emptyFilterData = userPage ? emptyFilterDataUser : emptyFilterDataApprover;

  const filterConfiguration = userPage
    ? filterConfigurationForUser
    : filterConfigurationForApprover;

  const toggleClose = () => {
    setOpen(false);
  };
  const toggleOpen = () => {
    setOpen(!open);
  };

  const getRequestsByEmployee = async () => {
    const response = await GetExternalHrsRequestsForEmployee(
      currentUserId,
      filterState,
      pageSize,
      pageNo,
      requestCategory,
    );
    setLoader(false);
    setTotalPage(response?.data?.data?.totalPages);
    setUserRequests(response?.data?.data?.content || []);
  };

  const getRequestsForFinance = async () => {
    const response = await GetExternalHrsRequestsForFinance(
      currentUserId,
      filterState,
      pageSize,
      pageNo,
      requestCategory,
    );
    setLoader(false);
    setTotalPage(response?.data?.data?.totalPages);
    setUserRequests(response?.data?.data?.content || []);
  };

  const getRequestsForSeniorManager = async () => {
    const response = await GetExternalHrsRequestsForSeniorManager(
      currentUserId,
      filterState,
      pageSize,
      pageNo,
    );
    setLoader(false);
    setTotalPage(response?.data?.data?.totalPages);
    setUserRequests(response?.data?.data?.content || []);
  };

  useEffect(() => {
    if (resetFilter) {
      if (userPage) getRequestsByEmployee();
      else if (financePage) getRequestsForFinance();
      else if (seniorManagerPage) getRequestsForSeniorManager();
    }
  }, [refresh, resetFilter, filterState, requestCategory]);

  const loadApplyEligibility = async () => {
    const projects = await getUserProjects(currentUserId, '', '', '', 'ACTIVE');
    const projectList =
      projects?.isError === false
        ? projects?.data?.content || projects?.data?.data?.content || []
        : [];
    const hasActiveProject =
      Array.isArray(projectList) &&
      projectList.some((project) => project.status === 'ACTIVE');
    setCanApplyExternalHours(hasActiveProject);
  };

  useEffect(() => {
    if (userPage) {
      loadApplyEligibility();
    }
  }, []);

  return (
    <>
      {loader || loader1 ? (
        <div>
          <GenericLoader rectAttributes={WFHAttribute} />
        </div>
      ) : (
        <Box>
          <Box>
            {checkFilterIconVisibility(
              filterState,
              emptyFilterData,
              userRequests,
            ) && (
              <GenericFilterDrawer
                options={options}
                disableDateRange={true}
                monthRangePicker={true}
              />
            )}
            {userRequests?.length === 0 ? (
              <Typography
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '50vh',
                }}
              >
                No Requests
              </Typography>
            ) : (
              Array.isArray(userRequests) &&
              userRequests.map((request) => (
                <ExternalHoursRequestCard
                  key={request.id}
                  requestId={request.id}
                  employeeName={request?.employeeName}
                  employeeCode={request?.employeeCode}
                  employeeId={request?.employeeId}
                  monthRange={request?.monthRange}
                  startDate={request?.startDate}
                  endDate={request?.endDate}
                  rangeType={request?.rangeType || 'MONTHLY'}
                  requestedHrs={request?.requestedHours}
                  requestCategory={request?.requestCategory || requestCategory || 'EXTERNAL'}
                  reason={request?.reason}
                  applicationStatus={request?.status}
                  HRApprovedHrs={request?.hrApprovedHours}
                  ApprovalData={
                    request?.externalHoursApplicationStatusDTOList || []
                  }
                  financePage={financePage}
                  seniorManagerPage={seniorManagerPage}
                  userPage={userPage}
                  toggleOpen={toggleClose}
                  setRefresh={setRefresh}
                  setLoader={setLoader}
                />
              ))
            )}
          </Box>
          {userRequests?.length ? (
            <Box className="page-holder" sx={{ padding: '8px' }}>
              <PaginationComponent
                count={totalPage}
                page={page}
                pageChange={pageChange}
                pageSize={pageSize}
                handlePageSizeChange={handlePageSizeChange}
              />
            </Box>
          ) : (
            <></>
          )}
          {userPage && (
            <Box className="main-content-overlay">
              <div className="main-content-div">
                <Tooltip
                  title={
                    canApplyExternalHours
                      ? ''
                      : `You can't apply for extra ${pageLabel}`
                  }
                  disableHoverListener={canApplyExternalHours}
                >
                  <span
                    style={{
                      right: 25,
                      bottom: 80,
                      position: 'fixed',
                      zIndex: 1051,
                      display: 'inline-block',
                    }}
                  >
                    <Fab
                      color="primary"
                      disabled={!canApplyExternalHours}
                      onClick={() => {
                        if (canApplyExternalHours) {
                          toggleOpen();
                        }
                      }}
                    >
                      <AddIcon />
                    </Fab>
                  </span>
                </Tooltip>
                <Dialog
                  open={open}
                  onClose={() => toggleClose()}
                  fullWidth
                  maxWidth="md"
                >
                  <ApplyExternalHours
                    toggleOpen={toggleClose}
                    setRefresh={setRefresh}
                    lockedCategory={requestCategory}
                  />
                </Dialog>
              </div>
            </Box>
          )}
        </Box>
      )}
    </>
  );
};

export default ExternalHours;
